import { Box } from "@mui/material";
import { ContentBlock, ContentState } from "draft-js";
import { VideoType } from "entities/faqs/types";
import React, { useEffect, useState } from "react";
import { StyledIframe, StyledVideoContainer } from "./styled";

type VideoContentProps = {
  src?: string;
  videoType?: VideoType;
  block?: ContentBlock;
  contentState?: ContentState;
};

const VideoContent: React.FC<VideoContentProps> = (props) => {
  const [videoData, setVideoData] = useState<{
    src: string;
    videoType: VideoType;
  } | null>(null);

  useEffect(() => {
    if (props.src && props.videoType) {
      setVideoData({
        src: props.src,
        videoType: props.videoType,
      });
      return;
    }

    if (props.block && props.contentState) {
      const entity = props.block.getEntityAt(0);
      if (entity) {
        const entityData = props.contentState.getEntity(entity).getData();
        if (entityData.src && entityData.videoType) {
          setVideoData({
            src: entityData.src,
            videoType: entityData.videoType,
          });
        }
      }
    }
  }, [props]);

  if (!videoData) {
    return (
      <Box
        width="100%"
        height="200px"
        bgcolor="#f0f0f0"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        Video data unavailable
      </Box>
    );
  }

  const getIframeAttributes = () => {
    const commonAttributes = {
      src: videoData.src,
      frameBorder: "0",
      allow:
        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowFullScreen: true,
    };

    switch (videoData.videoType) {
      case VideoType.Youtube:
        return {
          ...commonAttributes,
          title: "YouTube video player",
        };
      case VideoType.Vimeo:
        return {
          ...commonAttributes,
          title: "Vimeo video player",
          allow: "autoplay; fullscreen; picture-in-picture",
        };
      case VideoType.Loom:
        return {
          ...commonAttributes,
          title: "Loom video player",
        };
      default:
        return commonAttributes;
    }
  };

  return (
    <Box width="100%">
      <StyledVideoContainer>
        <StyledIframe {...getIframeAttributes()} />
      </StyledVideoContainer>
    </Box>
  );
};

export default VideoContent;
